"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getTests = exports.getFeatures = void 0;
exports.hasher = hasher;
var _fnv1a = _interopRequireDefault(require("@grandom/fnv1a"));
/**
 * Hashes the string using FNV-1a and XOR-folds the result to avoid FNV-1a's diffusion problem.
 * FNV-1a is very fast compared to crypto algorithms, and good enough for randomisation.
 * 👉 https://en.wikipedia.org/wiki/Fowler%E2%80%93Noll%E2%80%93Vo_hash_function
 *
 * @param salt the string to hash
 */
function hasher(salt) {
  const hash = (0, _fnv1a.default)(salt).toString(16);
  const half = hash.length / 2;

  // eslint-disable-next-line no-bitwise -- XOR fold the fnv1a hash
  return parseInt(hash.slice(0, half), 16) ^ parseInt(hash.slice(half), 16);
}
function matchesTraffic(_ref) {
  let {
    userAgent,
    language,
    affiliate,
    country,
    traffic = {}
  } = _ref;
  const uaOk = traffic.userAgent == null || new RegExp(traffic.userAgent).test(userAgent);
  const langOk = traffic.languages == null || traffic.languages.includes(language);
  const affiliateOk = traffic.affiliates == null || traffic.affiliates.includes(affiliate);
  const countryOk = traffic.countries == null || traffic.countries.includes(country);
  return uaOk && langOk && affiliateOk && countryOk;
}
const getGroup = _ref2 => {
  let {
    groups,
    userAgent,
    language,
    affiliate,
    country,
    salt
  } = _ref2;
  const candidates = groups.filter(_ref3 => {
    let {
      traffic
    } = _ref3;
    return matchesTraffic({
      traffic,
      userAgent,
      language,
      affiliate,
      country
    });
  });
  if (candidates.length === 0) {
    return null;
  }
  const hash = hasher(salt);
  const {
    name,
    tests
  } = candidates[hash % candidates.length];
  return {
    name,
    tests
  };
};
const getSaved = _ref4 => {
  let {
    groups,
    userAgent,
    language,
    affiliate,
    country,
    savedGroup
  } = _ref4;
  if (groups.length === 0 || savedGroup == null) {
    return null;
  }
  const candidate = groups.find(g => g.name === savedGroup);
  if (candidate == null) {
    return null;
  }
  const {
    traffic,
    name,
    tests
  } = candidate;
  const matches = matchesTraffic({
    traffic,
    userAgent,
    language,
    affiliate,
    country
  });
  if (!matches) {
    return null;
  }
  return {
    name,
    tests
  };
};
function getGroupTests(tests, salt) {
  return tests.filter(test => {
    if (test.values.find(v => v.weight < 0 || !Number.isInteger(v.weight)) != null) {
      /* eslint-disable no-console */
      console.warn(`[@kiwicom/darwin] The "weight" parameter must be a positive integer.`);
      console.warn(`[@kiwicom/darwin] Please adjust the parameter in test "${test.name}".`);
      console.warn(`[@kiwicom/darwin] Skipping the test for now.`);
      /* eslint-enable no-console */
      return false;
    }
    return true;
  }).map(test => {
    const hash = hasher(salt + test.name);
    const weightedValues = test.values.reduce((acc, next) => {
      return acc.concat(Array(next.weight).fill(next.value));
    }, []);
    return {
      name: test.name,
      value: weightedValues[hash % weightedValues.length]
    };
  });
}
const getTests = _ref5 => {
  let {
    config,
    userAgent = "",
    language = "",
    affiliate = "",
    country = "",
    salt,
    savedGroup
  } = _ref5;
  const {
    groups = []
  } = config;
  const saved = getSaved({
    groups,
    userAgent,
    language,
    affiliate,
    country,
    savedGroup
  });
  if (saved !== null) {
    return {
      group: saved.name,
      tests: getGroupTests(saved.tests, salt)
    };
  }
  const group = getGroup({
    groups,
    userAgent,
    language,
    affiliate,
    country,
    salt
  });
  if (group !== null) {
    return {
      group: group.name,
      tests: getGroupTests(group.tests, salt)
    };
  }
  return {
    group: null,
    tests: []
  };
};
exports.getTests = getTests;
const getFeatures = _ref6 => {
  let {
    config,
    userAgent = "",
    language = "",
    affiliate = "",
    country = ""
  } = _ref6;
  const {
    features = []
  } = config;
  return features.reduce((acc, _ref7) => {
    let {
      traffic,
      name,
      enabled
    } = _ref7;
    if (matchesTraffic({
      traffic,
      userAgent,
      language,
      affiliate,
      country
    })) {
      return {
        ...acc,
        [name]: enabled
      };
    }
    return {
      ...acc,
      [name]: false
    };
  }, {});
};
exports.getFeatures = getFeatures;